import _ from 'lodash';
import React, {Component, Fragment} from 'react';
import {ModalBody, ModalHeader, UncontrolledTooltip} from "reactstrap";
import {observer} from "mobx-react";

import UploadGallery from "../../../../../components/uploadgallery/UploadGallery";
import UploadGalleryStore from "../../../../../components/uploadgallery/uploadGalleryStore";
import {PostEditorFormFields} from "./formShapes";


@observer
export default class AddPhotoVideoAttachment extends Component {

  static propTypes = PostEditorFormFields;

  constructor(props) {
    super(props);
    this.uploadGalleryStore = new UploadGalleryStore();
  }

  addAttachment = () => {
    const { config } = this.props;
    const fileTypes = (!config.canAttachVideos || config.maxNumberOfVideos === 0) ? "images" : "images, video";
    const componentToRender = <Fragment>
      <ModalHeader toggle={() => this.props.closeModal()}>
        Upload an image or video
      </ModalHeader>
      <ModalBody>
        <UploadGallery
          uploadGalleryStore={this.uploadGalleryStore}
          fileTypes={fileTypes}
          imageSelectedCallback={(x) => {
            this.props.closeModal();
            const duration = !!x.duration ? {duration: x.duration} : {};
            const attachment = {
              attachmentType: x.type,
              url: x.url,
              width: x.width,
              height: x.height, ...duration
            };
            this.props.onChangeSetObject({attachments: _.concat(this.props.values.attachments, attachment)});
          }}
         />
      </ModalBody>
    </Fragment>;

    this.props.openModal(componentToRender)
  };

  renderVideoTooltip = () => {
    const { config } = this.props;
    if (config.maxNumberOfVideos === 0) return undefined;
    return (
      <UncontrolledTooltip placement="top" target="uploadMedia">
        Note: Only one video can be posted at a time and cannot be posted with other content.
        <br/><br/>
        eg. A video and one or more images, behavior will be to upload just the video.
        <br/><br/>
        eg. Two or more videos, behavior will be to post each video individually.
      </UncontrolledTooltip>
    );
  }

  render() {
    const { config } = this.props;
    const attachments = !!this.props.values.attachments ? this.props.values.attachments : [];
    const linkCount = _.filter(attachments, (x) => x.attachmentType === 'Link').length;
    const disabled = !this.props.config.canHaveMixedMedia && linkCount > 0;
    const label = (!config.canAttachVideos || config.maxNumberOfVideos === 0) ? "Add Photo" : "Add Photo or Video";

    return (
      !config.disableAttachments ?
        <span id="disabledMedia">
          <a id="uploadMedia" className={`p-2 d-flex flex-row justify-content-between text-secondary clickable ${disabled ? 'btn disabled' : ''}`} onClick={this.addAttachment}>
            <i className="fas fa-camera attachment-link"/>
            <div className="pl-2">
              { label }
            </div>
            { this.renderVideoTooltip() }
          </a>
          { (disabled) && <UncontrolledTooltip placement="top" target="disabledMedia">
            <span>
              You are not able to have mixed attachments for {this.props.provider}
            </span>
          </UncontrolledTooltip>}
        </span>
      : <div/>
    );
  }
}
